import AuthLogin from "legacy/auth/AuthLogin"
import AuthSignUpIntro from "legacy/auth/AuthSignUpIntro"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class AuthModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: "login",
      innerView: null,
      isInitialized: false,
    }
    this.setView = this.setView.bind(this)
    this.setLoginPage = this.setLoginPage.bind(this)
    this.setSignUpPage = this.setSignUpPage.bind(this)
  }

  componentDidMount() {
    if (this.props.initialView === "signup") {
      this.setSignUpPage()
    } else {
      this.setLoginPage()
    }
  }

  setView(view) {
    // apply required props to the view before setting it
    this.setState({
      innerView: React.cloneElement(view, {
        setView: (v) => this.setView(v),
        setLoginPage: () => this.setLoginPage(),
      }),
      isInitialized: true,
    })
  }

  setLoginPage() {
    this.setState({ active: "login" })
    this.setView(
      <AuthLogin setView={this.setView} setLoginPage={this.setLoginPage} />
    )
  }

  setSignUpPage() {
    this.setState({ active: "signup" })
    this.setView(
      <AuthSignUpIntro
        setView={this.setView}
        setLoginPage={this.setLoginPage}
      />
    )
  }

  render() {
    // Since we're removing inline support, always render as a modal
    if (!this.state.isInitialized) {
      return null
    }

    return (
      <Modal isOpen={true} onClose={this.props.closeModal} size="small">
        <Modal.Body>
          <div className="auth-modal mt-4">
            <div className="modal-body">{this.state.innerView}</div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

AuthModal.propTypes = {
  initialView: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
}

AuthModal.defaultProps = {
  initialView: "login",
}

export default AuthModal
